var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404ErrorDog(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.699 111.956l4.605-20.295 10.394 8.318-2.8 14.685-10.736 1.12-1.463-3.828z",
    fill: "#FFB93D",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.183 108.914s.095-2.111.095-3.359c0-1.759-.316-3.845-.727-5.608-.36-1.542-2.422-7.26-6.17-11.74-4.414-5.274-8.619-6.408-10.411-7.018-2.602-.885-5.109-1.07-7.303-.99l-6.003-7.825-2.069-5.855L97.52 67.85c0 4.183-.175 7.13-.53 8.334-.356 1.204-1.97 5.545-2.469 7.54-.498 1.997-1.395 7.2 1.01 11.93 2.406 4.73 5.991 7.082 9.361 7.747 3.37.666 10.822.238 10.822.238s12.474 9.021 14.557 9.458c6.644 1.394 16.912.633 16.912-4.183z",
    fill: "#FFB93D",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.339 87.178c2.026 1.49 4.367 1.648 5.506 1.68 1.139.03 4.312.252 5.601.696 1.218.42 2.436.887 3.448 2.376 1.013 1.49 2.347 3.617 2.912 4.278.49.574 1.17 1.402 2.625 1.584.843.105 1.694-.077 2.292-.264l.02-.008c-.971-2.492-2.761-6.201-5.365-9.313-4.413-5.275-8.619-6.41-10.41-7.019-2.603-.886-5.11-1.07-7.304-.99l-1.261-1.644c-.868 1.044-1.249 1.853-1.197 3.268.064 1.712 1.108 3.867 3.133 5.356z",
    fill: "#FFEECF",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.537 97.768c-2.35-1.425-4.272-2.827-7.879-2.827-3.607 0-6.966 1.283-8.995 3.184-2.231 2.091-2.672 3.657-2.753 6.013-.085 2.471 2.311 5.917 4.715 7.026 2.405 1.11 14.912 2.535 14.912 2.535",
    fill: "#FFB93D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.537 97.768c-2.35-1.425-4.272-2.827-7.879-2.827-3.607 0-6.966 1.283-8.995 3.184-2.231 2.091-2.672 3.657-2.753 6.013-.085 2.471 2.311 5.917 4.715 7.026 2.405 1.11 14.912 2.535 14.912 2.535",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81.16 119.941c0-2.281.51-3.915 1.787-5.609 1.471-1.948 3.963-3.311 6.076-3.311 1.732 0 3.742.15 5.617 1.79 1.875 1.64 1.709 7.13 1.709 7.13h-15.19z",
    fill: "#FFB93D",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M115.08 96.018c-1.709 9.126-4.588 23.923-4.588 23.923H91.696c0-2.028.023-3.153.649-4.626.716-1.683 2.276-3.236 3.844-4.04 1.22-.626 2.312-.81 3.415-.81.902 0 1.837.335 1.837.335s2.088-15.194 2.436-18.647c.348-3.453.574-5.874-.661-5.874-1.222 0-.416 2.65.878 3.636",
    fill: "#FFB93D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M115.08 96.018c-1.709 9.126-4.588 23.923-4.588 23.923H91.696c0-2.028.023-3.153.649-4.626.716-1.683 2.276-3.236 3.844-4.04 1.22-.626 2.312-.81 3.415-.81.902 0 1.837.335 1.837.335s2.088-15.194 2.436-18.647c.348-3.453.574-5.874-.661-5.874-1.222 0-.416 2.65.878 3.636",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.652 112.669c-1.53.523-2.009.839-2.42 1.45-.373.551-.547 1.271-.547 1.949 0 .677-.047 3.932-.047 3.932M100.715 112.669c-.934.365-2.042.897-2.469 1.695-.446.833-.494 1.378-.523 1.901-.036.639-.07 3.676-.07 3.676M87.155 112.669c-.871.411-1.725.793-2.215 1.807-.49 1.014-.459 1.631-.459 2.17v3.295M90.367 112.78c-.617.254-1.36.571-1.883 1.141-.459.499-.759 1.062-.838 2.059-.08.998 0 4.02 0 4.02",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M128.711 111.465c1.17-.463 1.479-.569 1.796-.642.295-.068.995-.092 1.392.096.32.15.411.265.411.404 0 .19-.467.555-1.029.665-.562.111-1.202 0-1.677-.142-.475-.142-3.149-1.227-4.232-1.671-1.084-.444-3.172-.756-5.4-.38-1.969.332-3.461.924-5.245 2.353-1.542 1.236-2.475 3.171-2.523 4.657-.033 1.01.008 3.138.008 3.138h31.98c1.091-1.117 2.444-2.424 2.515-4.92.973 0 1.613-.047 3.323-.832 1.71-.784 4.723-2.044 7.618-6.059 2.896-4.016 3.228-7.105 3.228-9.648 0-3.445-.605-8.332-5.055-12.214 0 0-1.97-1.759-4.96-2.757-.498-.166-.178.405.107.796.285.392 1.791 2.484 2.385 5.145.594 2.66.95 4.705.332 8.175-.617 3.469-1.97 5.833-4.123 7.437-1.134.844-2.76 1.213-2.76 1.213",
    fill: "#FFB93D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M128.711 111.465c1.17-.463 1.479-.569 1.796-.642.295-.068.995-.092 1.392.096.32.15.411.265.411.404 0 .19-.467.555-1.029.665-.562.111-1.202 0-1.677-.142-.475-.142-3.149-1.227-4.232-1.671-1.084-.444-3.172-.756-5.4-.38-1.969.332-3.461.924-5.245 2.353-1.542 1.236-2.475 3.171-2.523 4.657-.033 1.01.008 3.138.008 3.138h31.98c1.091-1.117 2.444-2.424 2.515-4.92.973 0 1.613-.047 3.323-.832 1.71-.784 4.723-2.044 7.618-6.059 2.896-4.016 3.228-7.105 3.228-9.648 0-3.445-.605-8.332-5.055-12.214 0 0-1.97-1.759-4.96-2.757-.498-.166-.178.405.107.796.285.392 1.791 2.484 2.385 5.145.594 2.66.95 4.705.332 8.175-.617 3.469-1.97 5.833-4.123 7.437-1.134.844-2.76 1.213-2.76 1.213",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M117.102 112.61c-1.069.332-1.866.683-2.48 1.64-.642.997-.715 1.849-.715 2.554v3.137M120.828 112.61c-1.044.402-1.999.972-2.456 1.806-.419.765-.523 1.355-.546 2.056-.023.701 0 3.47 0 3.47",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M160.691 95.508c-1.264.294-2.025.657-2.783 2.498-.878 2.132-.806 3.945-.71 5.063.082.974.599 2.362 1.673 3.16 1.767-3.111 2.006-5.62 2.006-7.746a22.395 22.395 0 00-.186-2.975z",
    fill: "#FFEECF",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.697 120c.957-4.622 2.603-8.234 5.007-11.086 2.405-2.852 7.214-5.83 11.012-7.478 3.797-1.648 13.797-5.387 17.278-7.73 3.481-2.344 8.166-5.934 10.206-14.639 1.787-7.636 4.635-8.157 6.365-8.157 1.656 0 3.677.797 5.011 3.943.798 1.885.443 5.956.443 5.956",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M109.962 80.555a2.984 2.984 0 00-2.982 2.986v4.647h5.966v-4.647a2.988 2.988 0 00-2.984-2.986z",
    fill: "#CCE6F0",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.745 94.122a.682.682 0 01-.682-.683v-3.642h1.364v3.642a.683.683 0 01-.682.683zM112.056 94.122a.682.682 0 01-.682-.683v-3.642h1.364v3.642a.683.683 0 01-.682.683z",
    fill: "#fff",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.221 90.378h7.308a1.093 1.093 0 000-2.189h-7.308a1.093 1.093 0 000 2.189z",
    fill: "#64E1A9",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M95.366 49.188c2.12-1.331 5.918-3.249 9.137-3.249 3.223 0 6.983 1.22 9.176 3.248 0 2.567 2.16 17.268-.162 18.885-1.218.992-4.955 4.3-8.943 4.3-3.987 0-7.646-3.223-9.044-4.586-2.41-2.185-.164-18.599-.164-18.599z",
    fill: "#FFB93D",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M98.528 60.335a1.066 1.066 0 10-.002-2.13 1.066 1.066 0 00.002 2.13z",
    fill: "#251EB4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.537 71.97c1.219 1.6 2.089 2.455 3.054 2.455.964 0 2.008-.847 2.895-2.566-1.581-.95-2.921-1.252-2.921-1.252l-3.028 1.362z",
    fill: "#fff",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M110.691 60.335a1.066 1.066 0 10-.002-2.131 1.066 1.066 0 00.002 2.131z",
    fill: "#251EB4"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M111.018 64.047c-.747-1.104-1.768-2.424-2.113-2.863-.344-.44-.518-1.379-.514-2.115.003-.737.075-2.828.122-3.815.048-.986-.148-2.135-.676-2.852-.503-.68-1.752-1.648-3.248-1.648-1.495 0-2.744.966-3.247 1.648-.528.717-.724 1.866-.676 2.852.047.986.118 3.077.122 3.815.003.736-.17 1.674-.515 2.115-.344.44-1.364 1.759-2.112 2.864-.747 1.104-1.174 2.044-1.174 3.47 0 1.424.64 2.34 1.34 3.064.528.546 1.264 1.31 2.243 1.675.843.315 2.51.273 2.908-.023.634-.474 1.111-1.076 1.111-1.325 0 .25.478.85 1.112 1.325.398.297 2.065.339 2.907.023.979-.366 1.716-1.13 2.243-1.675.7-.725 1.341-1.64 1.341-3.065s-.427-2.364-1.174-3.47z",
    fill: "#fff",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M95.366 49.188c0 3.611 0 11.533.096 14.67.095 3.136.22 7.984-.602 10.455-.823 2.47-1.93 4.309-4.684 5.577-2.752 1.267-5.459.292-6.486-2.472-1.046-2.81-1.044-5.83.158-10.171 1.202-4.342 2.5-7.224 4.746-10.741 2.574-4.027 4.905-5.925 6.772-7.318zM113.679 49.188c0 3.611 0 11.533-.096 14.67-.095 3.136-.221 7.984.602 10.455.823 2.472 1.93 4.309 4.684 5.577 2.752 1.267 5.459.292 6.486-2.472 1.046-2.81 1.044-5.83-.158-10.171-1.202-4.342-2.5-7.224-4.747-10.741-2.572-4.027-4.904-5.925-6.771-7.318z",
    fill: "#251EB4",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M104.713 63.525h2.225c1.319 0 2.336 1.077 2.336 1.538 0 .459.096.982-.285 1.473-.381.49-2.042 2.17-2.594 2.598-.554.427-.934.713-1.805.713h-.052c-.871 0-1.25-.286-1.804-.713-.554-.428-2.215-2.108-2.594-2.598-.38-.49-.286-1.014-.286-1.473 0-.46 1.018-1.538 2.336-1.538h2.523z",
    fill: "#251EB4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M104.59 70.91V69.79",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.974 74.694c2.405-2.63 3.115-6.359 2.977-12.358-.12-5.249-2.36-11.294-4.732-14.527-2.965 4.481-4.32 9.425-4.336 14.472-.015 5.188 2.169 10.067 4.375 12.412h1.716v.001z",
    fill: "#D8F7E9",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.774 59.76v14.776",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M26.146 74.694c-2.277-4.04-4.413-9.478-4.509-14.933-.095-5.456 2.326-12.87 6.124-19.761 3.607 4.183 5.221 8.935 5.79 13.783.57 4.847-.272 12.735-1.66 16.683-.968 2.748-1.78 3.874-2.089 4.348-.997-.001-3.656-.12-3.656-.12z",
    fill: "#64E1A9",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M27.684 54.59v20.223",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.801 74.813c-1.044-2.274-1.613-5.062-.38-9.18 1.235-4.12 4.59-8.08 6.298-9.6 1.709-1.522 2.469-1.807 2.469-1.807s.477 1.612.506 4.341c.02 1.886-.317 6.306-1.899 9.792-1.581 3.486-2.88 4.91-4.904 6.622-1.171-.033-2.09-.168-2.09-.168z",
    fill: "#64E1A9",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34.833 63.415L29.96 74.98",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M16.417 75.264c.696-1.331 2.078-5.3.917-10.86-1.012-4.855-3.586-8.531-6.09-10.86-1.851 4.183-2.137 8.317-1.567 12.548.57 4.234 3.085 7.557 5.315 9.172h1.425z",
    fill: "#64E1A9",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13 63.192l2.657 12.072",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32.128 119.941H13.806a5.463 5.463 0 01-5.459-5.467v-40.54h29.239v40.542a5.462 5.462 0 01-5.458 5.465z",
    fill: "#CCE6F0",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M37.586 73.934H8.347v10.931h29.239v-10.93z",
    fill: "#FAE7FA",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M37.586 73.934H8.347v4.943h29.239v-4.943z",
    fill: "#F5CFF6",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M74.308 65.126H48.06v13.941h26.248V65.126z",
    fill: "#CCE6F0",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M53.772 69.656l-1.52 1.64M55.67 69.656l1.59 1.64M54.697 72.651v2.066M66.824 69.656l-1.519 1.64M68.722 69.656l1.592 1.64M67.75 72.651v2.066M147.811 119.941H1.145",
    stroke: "#251EB4",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default Svg404ErrorDog;